import { CLIENT_METRIC_NAME, PERSONA_CHAT_FEEDBACK_COMPONENT, TAG_KEY } from '../conventions';
import { incrementClientMetric } from './increment-client-metric';

function recordClientPersonaChatFeedback(
  name:
    | typeof CLIENT_METRIC_NAME.PERSONA_CHAT_THUMBS_UP
    | typeof CLIENT_METRIC_NAME.PERSONA_CHAT_THUMBS_DOWN,
): void {
  incrementClientMetric({
    name,
    tags: { [TAG_KEY.COMPONENT]: PERSONA_CHAT_FEEDBACK_COMPONENT },
  });
}

export function recordClientPersonaChatThumbsUp(): void {
  recordClientPersonaChatFeedback(CLIENT_METRIC_NAME.PERSONA_CHAT_THUMBS_UP);
}

export function recordClientPersonaChatThumbsDown(): void {
  recordClientPersonaChatFeedback(CLIENT_METRIC_NAME.PERSONA_CHAT_THUMBS_DOWN);
}
